var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3215 2.71429H1.03575C0.661178 2.71429 0.357178 3.01829 0.357178 3.39286C0.357178 3.76743 0.661178 4.07143 1.03575 4.07143H2.48246L3.01853 17.0484C3.06332 18.1389 3.9604 19 5.05222 19C7.1429 19 11.2231 19 13.3104 19C14.3988 19 15.2946 18.1436 15.3441 17.0566L15.9345 4.07143H17.3215C17.696 4.07143 18 3.76743 18 3.39286C18 3.01829 17.696 2.71429 17.3215 2.71429ZM14.576 4.07143H3.84097L4.37433 16.9921C4.38926 17.3558 4.6885 17.6429 5.05222 17.6429H13.3104C13.6728 17.6429 13.972 17.3572 13.9883 16.9948L14.576 4.07143ZM11.2143 6.10714V15.6071C11.2143 15.9817 11.5183 16.2857 11.8929 16.2857C12.2675 16.2857 12.5715 15.9817 12.5715 15.6071V6.10714C12.5715 5.73257 12.2675 5.42857 11.8929 5.42857C11.5183 5.42857 11.2143 5.73257 11.2143 6.10714ZM5.78575 6.10714V15.6071C5.78575 15.9817 6.08975 16.2857 6.46432 16.2857C6.83889 16.2857 7.14289 15.9817 7.14289 15.6071V6.10714C7.14289 5.73257 6.83889 5.42857 6.46432 5.42857C6.08975 5.42857 5.78575 5.73257 5.78575 6.10714ZM7.14289 1.35714H11.2143C11.5889 1.35714 11.8929 1.05314 11.8929 0.678571C11.8929 0.304 11.5889 0 11.2143 0H7.14289C6.76832 0 6.46432 0.304 6.46432 0.678571C6.46432 1.05314 6.76832 1.35714 7.14289 1.35714Z",
    fill: "#1E294F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/delete-file.7f3b95d3ee49a41981debf660713cbf0.svg";
export { ForwardRef as ReactComponent };